import { useState } from 'react';
import { CheckCircle2, Copy } from '@/components/icons';
import { Button } from '@/components/ui';
import { copyText } from '@/lib/format';

/**
 * A value to copy (a URL, a token, a command) with a Copy button; `secret` shows it in the danger colour.
 * Long values wrap so all of it stays readable; a click selects it all for manual copying.
 */
export function CopyField({ label, value, secret }: { label: string; value: string; secret?: boolean }) {
  const [copied, setCopied] = useState(false);
  return (
    <div className="space-y-1">
      <div className="text-xs font-medium text-slate-500">{label}</div>
      <div className="flex items-start gap-2">
        <code
          className={`min-w-0 flex-1 cursor-text select-all break-all whitespace-pre-wrap rounded-lg bg-slate-100 px-3 py-2 text-xs dark:bg-slate-800 ${secret ? 'text-rose-700 dark:text-rose-300' : ''}`}
          title={value}
          onClick={(e) => window.getSelection()?.selectAllChildren(e.currentTarget)}
        >
          {value}
        </code>
        <Button
          size="sm"
          variant="outline"
          icon={copied ? <CheckCircle2 className="size-4" /> : <Copy className="size-4" />}
          onClick={async () => {
            if (await copyText(value)) {
              setCopied(true);
              setTimeout(() => setCopied(false), 2000);
            }
          }}
        >
          {copied ? 'Copied' : 'Copy'}
        </Button>
      </div>
    </div>
  );
}
